module.exports = __webpack_public_path__ + "img/social7.f5fe6416.svg";